import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

type IDisclaimerModalProps = {
  open: boolean;
  openModal: (param: string | null) => void;
  closeModal: () => void;
  link: string | null;
};

export const useDisclaimerModal = (isDisclaimerEnable: boolean): IDisclaimerModalProps => {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState<string | null>('');
  const studySwitcherTrigger = useSelector(
    (state: RootState) => state.studySwitcher.studySwitcherTrigger
  );

  const openModal = (param: string | null) => {
    setOpen(true);
    setLink(param);
  };
  const closeModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!isDisclaimerEnable) {
      return;
    }

    const handleAnchorClick = function (this: Element, e: Event) {
      const linkName = this.getAttribute('href');
      openModal(linkName);
      e.preventDefault();
    };

    const boundAnchors = new Set<Element>();

    const bindAnchors = () => {
      const anchors = Array.from(document.getElementsByClassName('open-disclaimer'));
      anchors.forEach((anchor) => {
        if (boundAnchors.has(anchor)) {
          return;
        }
        boundAnchors.add(anchor);
        anchor.addEventListener('click', handleAnchorClick);
      });
    };

    // Observe DOM changes so RichText / tab content links are bound after render.
    const observer = new MutationObserver(bindAnchors);
    observer.observe(document.body, { childList: true, subtree: true });
    bindAnchors();

    return () => {
      observer.disconnect();
      boundAnchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
      boundAnchors.clear();
    };
  }, [isDisclaimerEnable, studySwitcherTrigger]);

  return { open, openModal, closeModal, link };
};

export default useDisclaimerModal;
